import Image from 'next/image';
import Link from 'next/link';

const TabCTA = ({
  children,
  href = undefined,
  onClick = () => {},
  text = 'Click me!',
  icon = null
}) => (
  <div>
    <div>{children}</div>

    <div className="mx-auto max-w-full px-6 sm:px-0 pl-14 sticky bottom-14 mb-5 3xl:p-0 3xl:mt-5 3xl:bottom-1/2 z-50 3xl:min-w-0 sm:min-w-[350px] sm:max-w-max 3xl:mx-0">
      <div className="max-w-xs mx-auto relative 3xl:mx-0 3xl:max-w-[82px]">
        {href ? (
          <Link href={href}>
            <a className="bg-white 3xl:bg-gradient-x p-[1px] w-full 3xl:px-0 inline-block rounded-r-lg">
              <div className="bg-black 3xl:bg-gray-900 flex flex-col items-start 3xl:p-4 3xl:space-y-1 3xl:-translate-x-[1px] rounded-r-lg">
                {icon && (
                  <span className="hidden 3xl:flex">
                    <Image
                      quality={100}
                      layout="intrinsic"
                      src={icon.src}
                      width={icon.width}
                      height={icon.height}
                      loading="eager"
                      priority
                      alt={icon.alt}
                    />
                  </span>
                )}
                <p className="text-white mx-auto max-w-max leading-8 font-medium 3xl:font-normal 3xl:text-sm 3xl:leading-5 w-full py-[11px] 3xl:p-0 text-left flex items-center">
                  <span className="border-white border rounded-full px-3 py-[9.5px] flex 3xl:hidden absolute -left-8 bg-black">
                    <Image
                      quality={100}
                      layout="intrinsic"
                      src={icon.src}
                      width={30}
                      height={35}
                      loading="eager"
                      priority
                      alt={icon.alt}
                    />
                  </span>
                  {text}
                </p>
              </div>
            </a>
          </Link>
        ) : (
          <button
            type="button"
            onClick={onClick}
            className="bg-gradient-x py-[1px] rounded-l-full 3xl:rounded-l-0 rounded-r-lg 3xl:mb-4 3xl:max-w-[82px]"
          >
            <div className="bg-black 3xl:bg-gray-900 flex flex-col items-start 3xl:p-4 3xl:space-y-1 left-1/2 3xl:-translate-x-[1px] rounded-r-lg">
              {icon && (
                <span className="hidden 3xl:flex">
                  <Image
                    quality={100}
                    layout="intrinsic"
                    src={icon.src}
                    width={icon.width}
                    height={icon.height}
                    loading="eager"
                    priority
                    alt={icon.alt}
                  />
                </span>
              )}
              <p className="text-white mx-auto max-w-max leading-8 font-medium 3xl:font-normal 3xl:text-sm 3xl:leading-5 px-20 py-[11px] 3xl:p-0 text-left flex items-center">
                <span className="border-white border rounded-full px-3 py-[9.5px] flex 3xl:hidden absolute -left-8 bg-black">
                  <Image
                    quality={100}
                    layout="intrinsic"
                    src={icon.src}
                    width={30}
                    height={35}
                    loading="eager"
                    priority
                    alt={icon.alt}
                  />
                </span>
                {text}
              </p>
            </div>
          </button>
        )}
      </div>
    </div>
  </div>
);

export default TabCTA;
